import { createStyles, makeStyles } from '@mui/styles';
import { InspectionTemplateStatus } from 'shared/domain/template/templateStatus';
import { Color } from 'shared/utils/colors';

export const useStyles = makeStyles(() =>
  createStyles({
    templateStatus: {
      fontFamily: 'Archivo',
      fontStyle: 'normal',
      fontWeight: 700,
      letterSpacing: '0em',
      textTransform: 'capitalize',
      alignSelf: 'center',
      color: Color.neutralBorderGray,
    },
    small: {
      fontSize: '0.625rem',
      lineHeight: '11px',
    },
    [InspectionTemplateStatus.draft]: {
      color: Color.statusDraftAmber,
    },
    [InspectionTemplateStatus.published]: {
      color: Color.statusSuccessGreen,
    },
    default: {},
  })
);
